export default function getToken(auth: any) {
  const token = `Bearer ${auth.accessToken}`;
  return token;
}
